import {
  ICompaniesAllState,
  IRatingAgenciesState,
  ITopRatingAgenciesState,
  ITopUnderwritersState,
  IUnderwritersState,
} from '@/creditflowresearch/application/League/interfaces';
import useTopUnderwriters from './TopUnderwriters/useTopUnderwriters';
import useTopRatingAgencies from './TopRatingAgencies/useTopRatingAgencies';
import useUnderwriters from './Underwriters/useUnderwriters';
import useRatingAgencies from './RatingAgencies/useRatingAgencies';
import useCompaniesAll from './CompaniesAll/useCompaniesAll';

interface IProps {
  topUnderwritersInitialState: ITopUnderwritersState,
  topRatingAgenciesInitialState: ITopRatingAgenciesState,
  underwritersInitialState: IUnderwritersState,
  ratingAgenciesInitialState: IRatingAgenciesState,
  companiesAllInitialState: ICompaniesAllState,
}

export default (props:IProps) => {
  const { state: topUnderwritersCollection, ...topUnderwritersActions } = useTopUnderwriters(props);
  const { state: topRatingAgenciesCollection, ...topRatingAgenciesActions } = useTopRatingAgencies(props);
  const { state: underwritersCollection, ...underwritersActions } = useUnderwriters(props);
  const { state: ratingAgenciesCollection, ...ratingAgenciesActions } = useRatingAgencies(props);
  const { state: companiesAllCollection, ...companiesAllActions } = useCompaniesAll(props);

  return {
    state: {
      topUnderwritersCollection,
      topRatingAgenciesCollection,
      underwritersCollection,
      ratingAgenciesCollection,
      companiesAllCollection,
    },
    ...topUnderwritersActions,
    ...topRatingAgenciesActions,
    ...underwritersActions,
    ...ratingAgenciesActions,
    ...companiesAllActions,
  };
};
